import * as types from './types';

export const getStoreDataStart = () => ({
   type: types.GET_STORE_DATA_START,
});

export const getStoreDataCompleted = (data) => ({
   type: types.GET_STORE_DATA_COMPLETED,
   payload: data,
});

export const getStoreDataFailed = () => ({
   type: types.GET_STORE_DATA_FAILED,
});

export const updateStoreSettingsStart = () => ({
   type: types.UPDATE_STORE_SETTINGS_START,
});

export const updateStoreSettingsCompleted = (data) => ({
   type: types.UPDATE_STORE_SETTINGS_COMPLETED,
   payload: data,
});

export const updateStoreSettingsFailed = () => ({
   type: types.UPDATE_STORE_SETTINGS_FAILED,
});

export const setSelectedProduct = (product) => ({
   type: types.SET_SELECTED_PRODUCT,
   payload: product,
});

export const clearSelectedProduct = () => ({
   type: types.CLEAR_SELECTED_PRODUCT,
});
